import { Config } from '../config.es6';

/**
 * @classdesc メディアクエリ系のユーティリティクラス
 */
export default class MqUtils {

    /**
     * 指定したブレークポイントに基づいてMediaQueryListを取得
     * @param {string|number} size - Configで設定したブレークポイント名／数値（px）
     * @param {('min'|'max')} prefix - Configで設定したメディアクエリの種別（min／max）
     * @returns {MediaQueryList} MediaQueryListオブジェクト（.matchesで一致判定）
     */
    static getMq(size = 'wide', prefix = 'min') {
        if (typeof size === 'string') size = Config.BREAKPOINT[prefix][size];

        return window.matchMedia(`(${prefix}-width: ${size}px)`);
    }
}
